import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    continue: 'Add my SIRET number',
    descriptionCannotWait:
      'Before accessing your account, we need your SIRET number.\n' +
      'This number is used to verify your professional activity and for reglementation purposes, it has to be registered on your Shine account.',
    descriptionCanWait:
      'This number is used to verify your professional activity and for reglementation purposes, it has to be registered before {months} months.\n' +
      'You didn’t received it yet? We can remind you to fill it later.',
    headline: '{firstName}, we don’t have your SIRET number yet.',
    helpButton: 'Where can I find my SIRET?',
    remindLater: 'Remind me in 3 days',
    warningBox:
      'Without this number, after {months} months, we will have to temporarily lock your account untill you provide us your SIRET number.',
  },
  fr: {
    continue: 'Ajouter mon numéro SIRET',
    descriptionCannotWait:
      'Avant d’accéder à votre compte, nous avons besoin de votre numéro SIRET.\n' +
      'Ce numéro sert à justifier votre activité professionnelle et pour des raisons réglementaires, il doit être renseigné dans votre compte Shine.',
    descriptionCanWait:
      'Ce numéro sert à justifier votre activité professionnelle et pour des raisons réglementaires, il doit être renseigné sous {months} mois.\n' +
      'Vous ne l’avez pas encore reçu ? Nous pouvons vous le rappeler un peu plus tard.',
    headline: '{firstName}, votre numéro SIRET est manquant',
    helpButton: 'Où trouver mon SIRET ?',
    remindLater: 'Me relancer dans 3 jours',
    warningBox:
      'Sans ce numéro, au delà de {months} mois, nous serons dans l’obligation de suspendre momentanément l’accès à votre compte jusqu’à ce que vous nous transmettiez votre numéro SIRET.',
  },
});

export default locales;
